import { Checkbox } from "@/atoms"
import { SendOutlined } from "@/icons"
import { Form } from "@/organisms/Form"

export const ShareReportSectionForm = () => (
  <Form.Section.Template id="share" title="Share Report" Icon={SendOutlined}>
    <Form.Item name="sendEmail" valuePropName="checked">
      <Checkbox>Email me this report</Checkbox>
    </Form.Item>
  </Form.Section.Template>
)
